import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { Button, Modal, ModalBody } from "reactstrap";
import { AudioCallTitle, Href } from "../../../../Constants/Constants";
import { dynamicImage, Image } from "../../../../Utils";
import { Phone } from "react-feather";

const AudioCall = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{AudioCallTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered>
        <ModalBody className="p-0">
          <div className="audiocall1 call-modal">
            <Image className="bg-img img-fluid" src={dynamicImage("avtar/big/audiocall.jpg")} alt="Avatar" />
            <div className="center-con text-center">
              <div className="title2">Josephin water</div>
              <h6>log angelina california</h6>
              <ul>
                <li><Button color="success" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" onClick={toggle} href={Href}><Phone /></Button></li>
                <li><Button color="danger" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" onClick={toggle} href={Href}><Phone /></Button></li>
              </ul>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AudioCall;
